/* alterado em 07/11/2025 por CG — versão final estável (sem observer) */
document.addEventListener("DOMContentLoaded", () => {
  const baseCurrency = "EUR";
  const rates = {
    EUR: 1,
    USD: 1.18,
    CAD: 1.63,
    AUD: 1.78,
    JPY: 177.21,
    TRY: 48.92
  };
  const symbols = {
    EUR: "€",
    USD: "$",
    CAD: "$",
    AUD: "$",
    JPY: "¥",
    TRY: "₺"
  };

  const selector = document.getElementById("currencySelector");
  if (!selector) return;

  const saved = localStorage.getItem("ventura_currency") || baseCurrency;
  selector.value = saved;

  function convertAll(currency) {
    const multiplier = rates[currency] / rates[baseCurrency];
    const symbol = symbols[currency] || "";

    // converte todos os elementos com data-price-eur (catálogo, produto, cart)
    document.querySelectorAll("[data-price-eur]").forEach(el => {
      const baseValue = parseFloat(el.getAttribute("data-price-eur"));
      if (isNaN(baseValue)) return;

      const converted = baseValue * multiplier;
      const formatted = converted.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      el.textContent = `${symbol}${formatted}`;
    });

    // força reconversão no ORDER SUMMARY (subtotal/total)
    const summaryEls = document.querySelectorAll(".summary-row .ventura-price, .summary-total .ventura-price");
    summaryEls.forEach(el => {
      const baseValue = parseFloat(el.getAttribute("data-price-eur"));
      if (!isNaN(baseValue)) {
        const converted = baseValue * multiplier;
        const formatted = converted.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        el.textContent = `${symbol}${formatted}`;
      }
    });

    console.log(`[VENTURA] Converted to ${currency}`);
  }


  // conversão inicial
  convertAll(saved);

  // troca manual
  selector.addEventListener("change", e => {
    const currency = e.target.value;
    localStorage.setItem("ventura_currency", currency);
    convertAll(currency);
  });
  // ----------------------------------------------------
// Ventura Studio — Reaplica conversão após atualização AJAX do carrinho
// alterado em 07/11/2025 por CG
// ----------------------------------------------------
(function patchFetchForCartUpdates() {
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    // detecta qualquer atualização de /cart (Shopify AJAX)
    const url = args[0];
    if (typeof url === "string" && url.includes("/cart")) {
      response.clone().text().then(() => {
        setTimeout(() => {
          const current = localStorage.getItem("ventura_currency") || baseCurrency;
          convertAll(current);
        }, 400);
      });
    }

    return response;
  };
})();
});
